import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import { Spinner } from 'react-bootstrap';
import { Dialog } from 'primereact/dialog';
import { Button } from '../../../components/ui/Button';

import DevicesList from './assignPopup/devices/DevicesList';
import GroupsList from './assignPopup/groups/GroupsList';

import { useAssignCampaignDevices } from '../../../queries';
import { toggleDialog } from '../../../redux/Slices/Global/globalSlice';
import { setPageNum } from '../../../redux/Slices/scrollSlice';

function AssignPopup({ campaignId, campaignName }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { openDialog, campaignDetails } = useSelector((state) => state.global);

    const [selectedCategory, setSelectedCategory] = useState("devices");
    const [allSelected, setAllSelected] = useState(false);

    const [data, setData] = useState([]);
    const [ids, setIds] = useState([]);
    const assignCampaignDevices = useAssignCampaignDevices();



    const renderFooter = () => {
        return (
            <div>
                <Button
                    className="py-2 px-4   w-auto p-button-secondary p-button-sm"
                    label={t('buttons.cancel')}
                    disabled={assignCampaignDevices.isLoading}
                    onClick={onClose}
                />
                <Button
                    label={t('show.show_assign')}
                    loading={assignCampaignDevices.isLoading}
                    className="p-button-sm py-2 px-4 me-0"
                    disabled={assignCampaignDevices.isLoading || ids.length === 0}
                    onClick={assignToDevice}
                />
            </div>
        );
    };

    const assignToDevice = async () => {
        const data = {
            select_all: allSelected,
            campaign_id: campaignId,
            ...(selectedCategory === "devices" ? { devices_ids: ids, type: "devices" } : { groups_ids: ids, type: "groups" }),
        };

        await assignCampaignDevices.mutateAsync(data, {
            onSuccess: (data) => {
                const rejected = data?.rejected;
                if (rejected?.satellite?.length === 0) {
                    dispatch(toggleDialog("assignDeviceGroup"));
                }
            },
        });
    };

    const onClose = () => {
        dispatch(toggleDialog("assignDeviceGroup"));
    };



    const onCategoryChangeHandler = (category) => {
        setIds([]);
        setData([]);
        setSelectedCategory(category);
    };

    return (
        <Dialog
            id='assignDeviceDialog'
            header={t('show.show_select_screens', { name: campaignDetails.name || campaignName })}
            visible={openDialog.assignDeviceGroup}
            onHide={onClose}
            breakpoints={{ "960px": "95vw", "600px": "95vw" }}
            modal
            style={{ width: "min(95vw, 880px)", minHeight: "min(70vh, 560px)" }}
            footer={renderFooter}
        >
            <div className=" flex flex-column flex-lg-row device_assign_container border-top border-bottom min-h-[57vh]">
                <div className="w-full lg:w-[13%] flex   lg:flex-col text-capitalize border-end border-b">
                    <span
                        className={`px-3 py-2 cursor-pointer ${selectedCategory === "groups" ? "active_category" : ""}`}
                        onClick={() => onCategoryChangeHandler("groups")}
                    >
                        {t('show.show_groups')}
                    </span>
                    <span
                        className={`px-3 py-2 cursor-pointer ${selectedCategory === "devices" ? "active_category" : ""}`}
                        onClick={() => onCategoryChangeHandler("devices")}
                    >
                        {t('show.show_devices')}
                    </span>
                </div>
                <div className="w-full lg:w-[87%] d-flex flex-column justify-start">
                    <div className="d-flex flex-wrap justify-content-center  px-1">
                        {selectedCategory === "devices" ? (
                            <DevicesList
                                allSelected={allSelected}
                                setAllSelected={setAllSelected}
                                ids={ids}
                                setIds={setIds}
                            />
                        ) : (
                            <GroupsList
                                ids={ids}
                                setIds={setIds}

                            />
                        )}

                    </div>
                </div>
            </div>
        </Dialog>
    );
}

export default AssignPopup;
